export const DEFAULT_CAMPAIGN_KEY = '__default__';

const pluginsOnlyFeatures = [
    { label: 'Full Access to:', isHeader: true },
    { label: 'After Effects plugins', marginBottom: true },
    { label: 'Premiere Pro plugins', marginBottom: true },
    { label: 'LaForge Suite', marginBottom: true },
    { isDivider: true },
    { label: '5 Basic Assets Per Day', isHeader: true },
    { label: 'Access Basic Assets*', disabled: true },
];

const pluginsOnlyCardOverride = {
    name: 'Plugins Only',
    subtitle: 'Access all of our plugins',
    showDownloadsRow: false,
    features: pluginsOnlyFeatures,
};

const planCardOverrides = {
    [DEFAULT_CAMPAIGN_KEY]: {
        'plugins plan': {
            byPeriod: {
                month: pluginsOnlyCardOverride,
                year: pluginsOnlyCardOverride,
            },
            byEnvPlanId: {
                production: {},
                qa: {},
                development: {},
            },
        },
    },
};

export default planCardOverrides;
